import { Trash2Icon } from 'lucide-react'
import pluralize from 'pluralize'

import { Anchor } from '@/components/lemmala-design-system/anchor/anchor'
import { Button } from '@/components/lemmala-design-system/button/button'

type Category = {
  category: string
  questionCount: number
}

type QuestionnaireAnchorProps = {
  categories: Category[]
  onDeleteCategory?: (category: string) => void
}

export const QuestionnaireAnchor = ({ categories, onDeleteCategory }: QuestionnaireAnchorProps) => {
  return (
    <div className='shrink-0'>
      <Anchor
        items={categories.map(({ category, questionCount }) => ({
          id: category,
          title: (
            <div className='flex items-center gap-1'>
              <div>
                <div className='w-36 overflow-hidden text-ellipsis text-sm'>{category}</div>
                <div className='text-xs'>{pluralize('Question', questionCount, true)}</div>
              </div>
              {onDeleteCategory && (
                <Button
                  variant='ghost'
                  size='icon'
                  aria-label='Delete section'
                  className='size-5 text-main-foreground-tertiary hover:text-semantic-danger-500'
                  onClick={(e) => {
                    e.stopPropagation()
                    onDeleteCategory(category)
                  }}
                >
                  <Trash2Icon size={12} />
                </Button>
              )}
            </div>
          ),
        }))}
      />
    </div>
  )
}
